import styled from 'styled-components'

import { helpers } from 'styles'

import { ItemExpandable as DefaultItemExpandable } from 'components/Lists'

export const ItemExpandable = styled(DefaultItemExpandable)`
	background-color: ${helpers.color.cardSubsectionBackground};

	&:first-child {
		border-top: 1px solid ${helpers.color.separator};
	}

	&:last-child {
		border-bottom: none;
	}
`
